import { render } from "./MessageTagComponent.vue?vue&type=template&id=0c9e0708&scoped=true"
import script from "./MessageTagComponent.vue?vue&type=script&lang=js"
export * from "./MessageTagComponent.vue?vue&type=script&lang=js"

import "./MessageTagComponent.vue?vue&type=style&index=0&id=0c9e0708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9e0708"]])

export default __exports__